module.exports = __webpack_public_path__ + "static/media/logo.48369111.svg";